@if (!fileItemArray || fileItemArray.length==0) {
  <mat-dialog-content class="flex-col justify-start items-stretch w-100">
    <span>No file to display</span>
  </mat-dialog-content>
}
@else if (fileItemArray.length==1) {
  <mat-dialog-content class="flex-col justify-start items-stretch w-100">
    <app-show-file [fileItem]="fileItemArray[0]" (dataChanged)="onFileChanged()"></app-show-file>
  </mat-dialog-content>
}
@else{
  <mat-dialog-content class="flex-col justify-start items-stretch w-100">
    <mat-tab-group class="px-5">
      @for (fileItem of fileItemArray; track $index; let i = $index) {
        <mat-tab >
          <ng-template mat-tab-label><b>File {{i+1}}</b>@if (fileItem.added) { <span>: {{fileItem.added | date:"MM/dd/yyyy hh:mm:ss a"}}</span> } </ng-template>
          <app-show-file [fileItem]="fileItem" (dataChanged)="onFileChanged()"></app-show-file>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>
}
<mat-dialog-actions>
  <div class="w-100 mt-3 flex-row justify-end items-center">
    <a mat-button class="dialog-btn" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
  </div>
</mat-dialog-actions>
